module finadai.app.granters {
  export var NAME = "finadai.app.granters";
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider){
    $urlRouterProvider.when('/granters', '/granters/list');
    $stateProvider.state('app.granters', {
      templateUrl: 'app/granters/granters.tpl.html',
      url: '/granters'
    })
    .state('app.granters.list', {
      templateUrl: 'app/granters/list/list.tpl.html',
			controller: 'grantersListController',
      url: '/list'
    })
    .state('app.granters.create', {
      templateUrl: 'app/granters/create/create.tpl.html',
			controller: 'grantersCreateController',
      url: '/create',
      resolve: { data: () => { return {}; } }
    })
    .state('app.granters.detail', {
      templateUrl: 'app/granters/create/create.tpl.html',
			controller: 'grantersCreateController',
      url: '/detail/:agentId',
      resolve: {
        data: (grantersService: services.GrantersService, $stateParams) => {
          return grantersService.get($stateParams.agentId).then(response => {
            return { id: response.data.data.id, name: response.data.data.name, deposit_data: response.data.data.deposit_data };
          })
        }
      }
    });
  }
  export function run(){
    var granters = angular.module(NAME, [
      finadai.app.granters.list.NAME,
      finadai.app.granters.create.NAME
    ]);
    granters.config(ConfigRoutes);
  }
}
finadai.app.granters.run();